import axios from 'axios';
// OK OK

export const  axios_cabinets_getusers = async ()=>{
    return  await  axios.get(`/cabinets/getusers`,{headers:{'Accept':'application/json'} });
}

export const  axios_cabinets_getcabinetequipes = async (courtier)=>{
    return  await  axios.post(`/cabinets/getcabinetequipes`,{'courtier':courtier},{headers:{'Accept':'application/json'} }); 
}

export const  axios_cabinets_getequipesmanagers = async (listeidmanagers)=>{
    return  await  axios.post(`/cabinets/getequipesmanagers`,{'listeidmanagers':listeidmanagers},{headers:{'Accept':'application/json'} }); 
}

export const  axios_cabinets_modifyuser = async (newuser_complete,id_equipe)=>{
    return  await axios.post(`/cabinets/modifyuser`,{'user':newuser_complete,id_equipe});
}

export const  axios_cabinets_createuser = async (newuser_complete,id_equipe)=>{
    return  await axios.post(`/cabinets/createuser`,{'user':newuser_complete,id_equipe});
}

export const  axios_cabinets_deleteequipe = async (id_equipe)=>{
    await axios.post(`/cabinets/deleteequipe`,{'id':id_equipe});
}

export const  axios_cabinets_modifyequipe = async (newequipe,listemanagersids)=>{
    await axios.post('/cabinets/modifyequipe',{'equipe':newequipe,listemanagersids},{headers:{'Accept':'application/json'} });
}

export const  axios_cabinets_createequipe = async (newequipe,listemanagersids)=>{
    await axios.post('/cabinets/createequipe',{'equipe':newequipe,listemanagersids},{headers:{'Accept':'application/json'} });
}





